import { render, staticRenderFns } from "./StaffTypeSlidebar.vue?vue&type=template&id=7a7940fa"
import script from "./StaffTypeSlidebar.vue?vue&type=script&lang=js"
export * from "./StaffTypeSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports